import { environment } from 'src/environments/environment';
import { TokRequest, TokRequestType, User } from 'src/app/interfaces/user';

interface MultiPlanTokStripePlans {
  plan1: string;
  plan2: string;
}

/**
 * TOK request types that offer a choice of two plans rather than the single standard one.
 */
export const MULTI_PLAN_TOK_STRIPE_PLANS: Partial<Record<TokRequestType, MultiPlanTokStripePlans>> = {
  [TokRequestType.Rescue]: {
    plan1: environment.stripePlans.identibasePlus,
    plan2: environment.stripePlans.identiAlertTokBreeder,
  },
  [TokRequestType.BasePlusBreederSale]: {
    plan1: environment.stripePlans.atBasePlusB21KMandatory,
    plan2: environment.stripePlans.atAlertB21KMandatory,
  },
};

export const MULTI_PLAN_TOK_TYPES: TokRequestType[] = Object.keys(MULTI_PLAN_TOK_STRIPE_PLANS).map(Number);

/**
 * The user's multi-plan TOK request, or undefined when they have none. Callers still need to
 * AND this with the `isTokPlanSelectionAvailable` feature flag.
 */
export function getMultiPlanTokRequest(user: User): TokRequest | undefined {
  return user?.tokRequests?.find((tokRequest) => MULTI_PLAN_TOK_TYPES.includes(tokRequest.type));
}
